{
  "actions": "Aktionen",
  "actionsAvailable": "Aktionen verfügbar.",
  "clearSelection": "Auswahl löschen",
  "selected": "{count, plural, =0 {Nichts ausgewählt} other {# ausgewählt}}",
  "selectedAll": "Alles ausgewählt"
}
